export const COMPONENT_IDS = [
  'AppDownloadOptIn',
  'CrossSell',
  'EmailSignUp',
  'ExtendStay',
  'FlightsTripActivity',
  'GroupedTrip',
  'HeroCollection',
  'HotelsTonight',
  'LinksWidget',
  'MediaCardCollection',
  'MobileFlightsTripActivity',
  'MobileSearchFormAi',
  'MobileSearchFormCars',
  'MobileSearchFormCruises',
  'MobileSearchFormFlights',
  'MobileSearchFormHotels',
  'MobileSearchFormPackages',
  'PromoBanners',
  'SearchFormAi',
  'SearchFormCars',
  'SearchFormCruises',
  'SearchFormFlights',
  'SearchFormHotels',
  'SearchFormPackages',
  'SpotlightCollection',
  'TripActivity',
  'WhyPricelineBanner',
] as const

export type ComponentId = (typeof COMPONENT_IDS)[number]

export type LogComponentLoadParams = {
  componentId: ComponentId
  loadTimeMs: number
  isMobile: boolean
  cguid: string
  pageName: string
}

export type LogComponentTapParams = {
  componentId: ComponentId
  target: string
  isMobile: boolean
  cguid: string
  pageName: string
}
